import { styles } from '@embeddable.com/remarkable-ui/styles';

const stylesRemarkablePro = {
  // Filter Builder
  '--em-filterbuilder-gap': 'var(--em-core-spacing--0300)',
  '--em-filterbuilder-font-family': 'var(--em-core-font-family--base)',
  '--em-filterbuilder-font-weight': 'var(--em-core-font-weight--medium)',
  '--em-filterbuilder-font-size': 'var(--em-core-font-size--xs)',
  '--em-filterbuilder-filter-gap': 'var(--em-core-spacing--0050)',
  '--em-filterbuilder-add-button-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-add-button-gap': 'var(--em-core-spacing--0050)',
  '--em-filterbuilder-add-button-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-add-button-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-add-button-background': 'var(--em-sem-background--light)',
  '--em-filterbuilder-add-button-background--hover': 'var(--em-sem-background--subtle)',
  '--em-filterbuilder-add-button-padding-y': 'var(--em-core-spacing--0000)',
  '--em-filterbuilder-add-button-padding-x': 'var(--em-core-spacing--0300)',
  '--em-filterbuilder-add-button-border-radius': 'var(--em-core-border-radius--400)',
  '--em-filterbuilder-add-button-color': 'var(--em-sem-text--neutral)',
  '--em-filterbuilder-add-button-icon-size': 'var(--em-core-size--0400)',
  '--em-filterbuilder-member-button-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-member-button-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-member-button-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-member-button-background': 'var(--em-sem-background--light)',
  '--em-filterbuilder-member-button-background--hover': 'var(--em-sem-background--subtle)',
  '--em-filterbuilder-member-button-padding-y': 'var(--em-core-spacing--0000)',
  '--em-filterbuilder-member-button-padding-x': 'var(--em-core-spacing--0300)',
  '--em-filterbuilder-member-button-border-left-radius': 'var(--em-core-border-radius--400)',
  '--em-filterbuilder-member-button-border-right-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-delete-button-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-delete-button-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-delete-button-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-delete-button-background': 'var(--em-sem-background)',
  '--em-filterbuilder-delete-button-background--hover': 'var(--em-sem-background--subtle)',
  '--em-filterbuilder-delete-button-padding-y': 'var(--em-core-spacing--0100)',
  '--em-filterbuilder-delete-button-padding-x': 'var(--em-core-spacing--0100)',
  '--em-filterbuilder-delete-button-color': 'var(--em-sem-text--muted)',
  '--em-filterbuilder-delete-button-border-left-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-delete-button-border-right-radius': 'var(--em-core-border-radius--400)',
  '--em-filterbuilder-delete-button-icon-size': 'var(--em-core-size--0400)',
  '--em-filterbuilder-operator-button-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-operator-button-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-operator-button-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-operator-button-background': 'var(--em-sem-background)',
  '--em-filterbuilder-operator-button-background--hover': 'var(--em-sem-background--subtle)',
  '--em-filterbuilder-operator-button-padding-y': 'var(--em-core-spacing--0100)',
  '--em-filterbuilder-operator-button-padding-x': 'var(--em-core-spacing--0100)',
  '--em-filterbuilder-operator-button-color': 'var(--em-sem-text--muted)',
  '--em-filterbuilder-operator-button-border-left-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-operator-button-border-right-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-value-button-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-value-button-gap': 'var(--em-core-spacing--0050)',
  '--em-filterbuilder-value-button-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-value-button-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-value-button-background': 'var(--em-sem-background--light)',
  '--em-filterbuilder-value-button-background--hover': 'var(--em-sem-background--subtle)',
  '--em-filterbuilder-value-button-padding-y': 'var(--em-core-spacing--0000)',
  '--em-filterbuilder-value-button-padding-x': 'var(--em-core-spacing--0300)',
  '--em-filterbuilder-value-button-border-left-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-value-button-border-right-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-value-button-color': 'var(--em-sem-text--neutral)',
  '--em-filterbuilder-value-button-icon-size': 'var(--em-core-size--0400)',
  '--em-filterbuilder-value-button-min-width': 'var(--em-core-size--1000)',
  '--em-filterbuilder-clear-button-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-clear-button-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-clear-button-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-clear-button-background': 'transparent',
  '--em-filterbuilder-clear-button-background--hover': 'var(--em-sem-background--light)',
  '--em-filterbuilder-clear-button-padding-y': 'var(--em-core-spacing--0000)',
  '--em-filterbuilder-clear-button-padding-x': 'var(--em-core-spacing--0300)',
  '--em-filterbuilder-clear-button-border-radius': 'var(--em-core-border-radius--400)',
  '--em-filterbuilder-clear-button-color': 'var(--em-sem-text--muted)',
  '--em-filterbuilder-scroll-right-button-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-scroll-right-button-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-scroll-right-button-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-scroll-right-button-background': 'transparent',
  '--em-filterbuilder-scroll-right-button-background--hover': 'var(--em-sem-background--light)',
  '--em-filterbuilder-scroll-right-button-padding-y': 'var(--em-core-spacing--0000)',
  '--em-filterbuilder-scroll-right-button-padding-x': 'var(--em-core-spacing--0300)',
  '--em-filterbuilder-scroll-right-button-border-left-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-scroll-right-button-border-right-radius': 'var(--em-core-border-radius--400)',
  '--em-filterbuilder-scroll-right-button-color': 'var(--em-sem-text--neutral)',
  '--em-filterbuilder-scroll-right-button-icon-size': 'var(--em-core-size--0400)',
  '--em-filterbuilder-scroll-left-button-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-scroll-left-button-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-scroll-left-button-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-scroll-left-button-background': 'transparent',
  '--em-filterbuilder-scroll-left-button-background--hover': 'var(--em-sem-background--light)',
  '--em-filterbuilder-scroll-left-button-padding-y': 'var(--em-core-spacing--0000)',
  '--em-filterbuilder-scroll-left-button-padding-x': 'var(--em-core-spacing--0300)',
  '--em-filterbuilder-scroll-left-button-border-left-radius': 'var(--em-core-border-radius--400)',
  '--em-filterbuilder-scroll-left-button-border-right-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-scroll-left-button-color': 'var(--em-sem-text--neutral)',
  '--em-filterbuilder-scroll-left-button-icon-size': 'var(--em-core-size--0400)',
  '--em-filterbuilder-value-input-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-value-input-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-value-input-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-value-input-padding-y': 'var(--em-core-spacing--0000)',
  '--em-filterbuilder-value-input-padding-x': 'var(--em-core-spacing--0300)',
  '--em-filterbuilder-value-input-border-left-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-value-input-border-right-radius': 'var(--em-core-border-radius--100)',
  '--em-filterbuilder-value-input-color': 'var(--em-sem-text--neutral)',
  '--em-filterbuilder-value-input-min-width': 'var(--em-core-size--1200)',
  '--em-filterbuilder-value-input-background': 'var(--em-sem-background--light)',
  '--em-filterbuilder-value-input-background--hover': 'var(--em-sem-background--subtle)',
  '--em-filterbuilder-andor-button-height': 'var(--em-core-size--0800)',
  '--em-filterbuilder-andor-button-border-width': 'var(--em-core-border-width--000)',
  '--em-filterbuilder-andor-button-border-color': 'rgb(255 255 255 / 0%)',
  '--em-filterbuilder-andor-button-background': 'var(--em-sem-background--light)',
  '--em-filterbuilder-andor-button-background--hover': 'var(--em-sem-background--subtle)',
  '--em-filterbuilder-andor-button-padding-y': 'var(--em-core-spacing--0000)',
  '--em-filterbuilder-andor-button-padding-x': 'var(--em-core-spacing--0300)',
  '--em-filterbuilder-andor-button-border-radius': 'var(--em-core-border-radius--400)',
  '--em-filterbuilder-andor-button-color': 'var(--em-sem-text--neutral)',

  // Drilldown Modal
  '--em-drilldown-modal-min-height': '100%',
  '--em-drilldown-modal-width': '100%',
};

export type StylesRemarkablePro = typeof stylesRemarkablePro;

// Merge base styles with remarkable pro styles
export const remarkableThemeStyles = { ...styles, ...stylesRemarkablePro } as const;
